import { PreviewResponse, PreviewFilters } from './types';

export async function fetchDraftPreview(packId: string, params: PreviewFilters): Promise<PreviewResponse> {
  const queryParams = new URLSearchParams();
  
  if (params.page) queryParams.append('page', params.page.toString());
  if (params.pageSize) queryParams.append('pageSize', params.pageSize.toString());
  if (params.operatorId) queryParams.append('operatorId', params.operatorId);
  if (params.formatId) queryParams.append('formatId', params.formatId);
  if (params.region) queryParams.append('region', params.region);
  if (params.unresolvedOnly) queryParams.append('unresolvedOnly', params.unresolvedOnly.toString());

  const response = await fetch(`/api/packs/${packId}/preview?${queryParams}`);
  
  if (!response.ok) {
    throw new Error(`Failed to fetch preview: ${response.statusText}`);
  }
  
  return response.json();
}

export async function fetchPackMeta(packId: string): Promise<{
  id: number;
  name: string;
  createdAt?: string;
  updatedAt?: string;
  retailer: {
    id: number;
    name: string;
  };
  status: 'unlocked' | 'locked';
  latestVersion?: {
    id: number;
    version: number;
    locked_at: string;
    locked_by: number;
  };
}> {
  const response = await fetch(`/api/packs/${packId}/meta`);
  
  if (!response.ok) {
    throw new Error(`Failed to fetch pack metadata: ${response.statusText}`);
  }
  
  return response.json();
}
